import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Categories from "./pages/Categories";
import Vendors from "./pages/Vendors";
import Items from "./pages/Items";
import Campuses from "./pages/Campuses";
import CentralInventory from "./pages/CentralInventory";
import CampusInventory from "./pages/CampusInventory";
import AllInventories from "./pages/AllInventories";
import CampusAllotments from "./pages/CampusAllotments";
import AllAllotments from "./pages/AllAllotments";
import Requests from "./pages/Requests";
import CampusRequests from "./pages/CampusRequests";
import Roles from "./pages/Roles";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import ActivityLog from "./pages/ActivityLog";
import Notifications from "./pages/Notifications";
import ForgotPassword from "./pages/ForgotPassword";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setAuthenticated } from "./store/slices/authSlice";
import { Toaster } from "react-hot-toast";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    if (sessionStorage.getItem("auth") === "1") {
      dispatch(setAuthenticated(true));
    }
  }, [dispatch]);
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
        }}
      />
      <Routes>
        {/* Public Routes */}
        <Route path="/account/login" element={<Login />} />
        <Route path="/account/forgot-password" element={<ForgotPassword />} />
        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="categories" element={<Categories />} />
          <Route path="vendors" element={<Vendors />} />
          <Route path="items" element={<Items />} />
          <Route path="campuses" element={<Campuses />} />
          <Route path="central-inventory" element={<CentralInventory />} />
          <Route path="campus-inventory" element={<CampusInventory />} />
          <Route path="all-inventories" element={<AllInventories />} />
          <Route path="campus-allotments" element={<CampusAllotments />} />
          <Route path="all-allotments" element={<AllAllotments />} />
          <Route path="requests" element={<Requests />} />
          <Route path="campus-requests" element={<CampusRequests />} />
          <Route path="roles" element={<Roles />} />
          <Route path="users" element={<Users />} />
          <Route path="settings" element={<Settings />} />
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="notifications" element={<Notifications />} />
        </Route>

        {/* Catch all unknown routes and redirect to dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
